export default class ChannelService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params){
		return this.apiService.callGet('channels/'+id, params);
	}

	getEntities(params) {
		return this.apiService.callGet('channels', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPost('channels/'+id, params)
	}

	searchChannelsByName(params){
		return this.apiService.callGet('me/channels/search', params);
	}

	searchChannelIdEpgsByName(params){
		return this.apiService.callGet('me/channels/search', {...params, use_id_epg: true});
	}

	channelList(params){
		return this.apiService.callGet('me/channels/channel_list', params);
	}

	epgChannelList(){
		return this.apiService.callGet('me/channels/epg_channel_list');
	}
}



// WEBPACK FOOTER //
// ./src/service/ChannelService.js